import { authAPI } from '../services/api';
import { logout } from '../store/slices/authSlice';

const SENSITIVE_STORAGE_KEYS = [
  'token',
  'user',
  'userId',
  'platformRole',
  'currentWorkspaceId',
  'sa_original_token',
  'sa_original_user',
  'workspaceToken',
  'workspaceUser',
];

export const clearSensitiveAuthState = () => {
  SENSITIVE_STORAGE_KEYS.forEach((key) => localStorage.removeItem(key));
  sessionStorage.removeItem('token');
  sessionStorage.removeItem('user');

  const logoutEventTs = Date.now().toString();
  localStorage.setItem('elvoaq_logout_event', logoutEventTs);
  window.dispatchEvent(new CustomEvent('elvoaq:logout', { detail: { at: logoutEventTs } }));
};

export const secureLogout = async (
  dispatch: (action: any) => void,
  navigate: (path: string, options?: { replace?: boolean }) => void,
  redirectPath = '/login'
) => {
  try {
    await authAPI.logout();
  } catch (error) {
    console.warn('Server logout failed, continuing with local logout:', error);
  } finally {
    clearSensitiveAuthState();
    dispatch(logout());
    navigate(redirectPath, { replace: true });
  }
};
